import EmailBlock from './EmailBlock';

export default EmailBlock;
